import { useRecordModal } from 'hooks/useRecordModal';
import { useRecordContext } from 'react-admin';
import { Switch } from 'shared/mui/Switch';
import { MerchantNotification } from 'types/embedded/merchantNotification';

import { MerchantsShowNotificationsDeliveryChannelActivityFieldSwitchConfirmOff } from './MerchantsShowNotificationsDeliveryChannelActivityFieldSwitchConfirmOff';
import { MerchantsShowNotificationsDeliveryChannelActivityFieldSwitchConfirmOn } from './MerchantsShowNotificationsDeliveryChannelActivityFieldSwitchConfirmOn';

export const MerchantsShowNotificationsDeliveryChannelActivityFieldSwitch: React.FC = () => {
  const {
    handleOpenRecordModal: handleOpenRecordModalOff,
    handleCloseRecordModal: handleCloseRecordModalOff,
    openRecordModal: openRecordModalOff,
  } = useRecordModal();
  const {
    handleOpenRecordModal: handleOpenRecordModalOn,
    handleCloseRecordModal: handleCloseRecordModalOn,
    openRecordModal: openRecordModalOn,
  } = useRecordModal();
  const record = useRecordContext<MerchantNotification>();

  const toggleActiveGatewayRule = () => {
    record?.active ? handleOpenRecordModalOff(record) : handleOpenRecordModalOn(record);
  };

  if (!record) {
    return <></>;
  }

  return (
    <>
      <MerchantsShowNotificationsDeliveryChannelActivityFieldSwitchConfirmOff
        notification={record}
        onClose={handleCloseRecordModalOff}
        open={openRecordModalOff}
      />
      <MerchantsShowNotificationsDeliveryChannelActivityFieldSwitchConfirmOn
        notification={record}
        onClose={handleCloseRecordModalOn}
        open={openRecordModalOn}
      />
      <Switch
        checked={record.active}
        onClick={toggleActiveGatewayRule}
        size="small"
        sx={{ marginRight: '16px' }}
      />
    </>
  );
};
